import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getMember, getProjectTask } from '../../../redux/MainAction';
import moment from 'moment';
import AddTaskModel from './AddTaskModel';
import EditTask from './EditTask';
import PaginationComponent from '../filters/PaginationComponent';
import ProjectTaskDetails from './ProjectTaskDetails';

const ProjectTaskList = () => {
  const dispatch = useDispatch();
  const tsk = useSelector((state) => state?.Webtracker?.projectTask);
  const emp = useSelector((state) => state?.Webtracker?.member);

  const [taskData, setTaskData] = useState([]);

  const [showReset, setShowReset] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;

  const [filter, setFilter] = useState({
    employeeIds: '',
    search: '',
    taskStatuses: '',
  });

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editID, setEditID] = useState('');

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDetailsModal = (id) => {
    setEditID(id);
    setIsDetailsModalOpen(!isDetailsModalOpen);
  };

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
      // projectId: params?.id,
    };
    dispatch(getProjectTask(data));
  };

  useEffect(() => {
    getList();
  }, [page]);

  useEffect(() => {
    dispatch(getMember());
  }, []);

  useEffect(() => {
    if (tsk && tsk.rows) {
      setTaskData(tsk?.rows);
      setTotalPages(Math.ceil(tsk?.count / itemsPerPage));
    }
  }, [tsk, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const toggleModalEdit = (id) => {
    setIsEditOpen(!isEditOpen);
    setEditID(id);
  };

  const handleApply = (e) => {
    e.preventDefault();
    const payload = {
      offset: 0,
      limit: 10,
      // projectId: params?.id,
    };

    if (filter?.search?.trim()) {
      payload.search = filter.search.trim();
    }

    if (filter?.employeeIds !== '') {
      payload.employeeIds = [filter.employeeIds];
    }

    if (filter?.taskStatuses !== '') {
      payload.taskStatuses = [filter.taskStatuses];
    }
    dispatch(getProjectTask(payload));
    setShowReset(true);
  };

  const handleReset = () => {
    const payload = {
      offset: 0,
      limit: 10,
      // projectId: params?.id,
    };
    dispatch(getProjectTask(payload));
    setFilter({
      employeeIds: '',
      search: '',
      taskStatuses: '',
    });
    setShowReset(false);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex justify-content-between align-items-center mb-2 ml-2">
          <h5 className="text-muted"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Button
              className="d-flex align-items-center"
              color="primary"
              size="sm"
              onClick={toggleModal}
            >
              + Add Task
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {isModalOpen && (
                <AddTaskModel open={isModalOpen} onClose={toggleModal} />
              )}
              <div className="card ">
                <div className="d-flex justify-content-between align-items-center m-3">
                  <div
                    className="d-flex justify-content-start align-items-center"
                    style={{ gap: '10px' }}
                  >
                    <div className="border rounded p-1">
                      <i className="fa fa-search text-muted ml-2 font-weight-light"></i>
                      <input
                        className="search_bar ml-2"
                        type="text"
                        placeholder="Search"
                        name="search"
                        value={filter?.search}
                        onChange={onChangeFilter}
                      />
                    </div>
                    <div className="fillSelect">
                      <i className="mdi mdi-account font-20 fillIcon"></i>
                      <select
                        className="form-control font-14"
                        name="employeeIds"
                        value={filter?.employeeIds}
                        onChange={onChangeFilter}
                      >
                        <option value="">All Members</option>
                        {emp?.rows?.map((mems, idx) => (
                          <option key={idx} value={mems?.id}>
                            {mems?.firstName} {mems?.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="fillSelect">
                      <i className="mdi mdi-briefcase font-20 fillIcon"></i>
                      <select
                        className="form-control font-14"
                        name="taskStatuses"
                        value={filter?.taskStatuses}
                        onChange={onChangeFilter}
                      >
                        <option value="">All Task Status</option>
                        <option value="OPEN">Open</option>
                        <option value="IN-PROGRESS">In-progress</option>
                        <option value="DONE">Done</option>
                        <option value="CLOSED">Closed</option>
                      </select>
                    </div>

                    <Button
                      className="d-flex align-items-center justify-content-center"
                      style={{ padding: '6px 14px' }}
                      size="sm"
                      color="primary"
                      onClick={handleApply}
                    >
                      <i className="ion-ios7-search font-20"></i>
                    </Button>
                    {showReset ? (
                      <Button
                        className="d-flex align-items-center justify-content-center"
                        style={{ padding: '6px 13px' }}
                        size="sm"
                        color="danger"
                        onClick={handleReset}
                      >
                        <i className="mdi mdi-close font-20"></i>
                      </Button>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="card-body" style={{ overflow: 'auto' }}>
                  <table
                    id="datatable"
                    className="table  dt-responsive nowrap table-vertical"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Task</th>
                        <th>Task Id</th>
                        <th>Project</th>
                        <th>Due Date</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskData?.length > 0 ? (
                        taskData?.map((tsx, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                            <td>
                              <div className="">{tsx?.name}</div>
                            </td>
                            <td>
                              <div>{tsx?.taskId}</div>
                            </td>
                            <td>
                              <div>{tsx?.project?.name}</div>
                            </td>
                            <td>
                              <div>
                                {tsx?.endDate
                                  ? moment(tsx?.endDate).format('YYYY-MM-DD')
                                  : 'No due date'}
                              </div>
                            </td>
                            <td>
                              <span
                                className={
                                  tsx?.priority === 'URGENT'
                                    ? 'rl_status bg-danger'
                                    : tsx?.priority === 'HIGH'
                                      ? 'rl_status bg-warning'
                                      : tsx?.priority === 'NORMAL'
                                        ? 'rl_status bg-info'
                                        : 'rl_status bg-purple'
                                }
                              >
                                {tsx?.priority === 'URGENT'
                                  ? 'Urgent'
                                  : tsx?.priority === 'HIGH'
                                    ? 'High'
                                    : tsx?.priority === 'NORMAL'
                                      ? 'Normal'
                                      : '' || 'Low'}
                              </span>
                            </td>

                            <td>
                              <span
                                className={
                                  tsx?.taskStatus === 'DONE'
                                    ? 'rl_status bg-success'
                                    : tsx?.taskStatus === 'CLOSED'
                                      ? 'rl_status bg-warning'
                                      : tsx?.taskStatus === 'IN-PROGRESS'
                                        ? 'rl_status bg-teal'
                                        : 'rl_status bg-indigo'
                                }
                              >
                                {tsx?.taskStatus === 'DONE'
                                  ? 'Done'
                                  : tsx?.taskStatus === 'IN-PROGRESS'
                                    ? 'In Progress'
                                    : tsx?.taskStatus === 'CLOSED'
                                      ? 'Closed'
                                      : '' || 'Open'}
                              </span>
                            </td>
                            <td>
                              <div
                                className="d-flex align-items-center justify-content-end w-100"
                                style={{ gap: '0.5rem' }}
                              >
                                <i
                                  className="mdi mdi-lead-pencil font-20 text-primary"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => toggleModalEdit(tsx?.id)}
                                  title="Edit Task"
                                ></i>

                                <i
                                  className="mdi mdi-eye font-20 text-muted"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => toggleDetailsModal(tsx?.id)}
                                  title="Show Task Details"
                                ></i>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <PaginationComponent
                    count={totalPages}
                    page={page}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isEditOpen && (
        <EditTask open={isEditOpen} onClose={toggleModalEdit} ID={editID} />
      )}

      {isDetailsModalOpen && (
        <ProjectTaskDetails
          open={isDetailsModalOpen}
          onClose={toggleDetailsModal}
          ID={editID}
        />
      )}
    </AUX>
  );
};

export default ProjectTaskList;
